<template>
    <header class="quiz-header container-sm">
      <span v-if="hasQuizPosition" class="quiz-position">
        <span class="quiz-position-label">
          {{ $t('viewer.page.header.label', { quizCount: quizPosition }) }}
        </span>
      </span>
      <span class="quiz-type">
        <span class="quiz-type-label">
          {{ $t(pageTypeName) }}
        </span>
      </span>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';

import quiz from '@/mixins/quiz';

export default {
  name: 'quiz-header',

  mixins: [quiz],

  props: {
    hasQuizPosition: {
      type: Boolean,
      default: false,
    },
    quizPosition: {
      type: Number,
      default: 1,
    },
    pageType: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters({
      pageTypes: 'pageTypes',
    }),

    pageTypeName() {
      if (!this.pageType) return '';
      return this.pageTypes[this.pageType.name];
    },
  },
};
</script>

<style lang="scss" scoped>
  .quiz-header {
    padding-top: 18px;
    padding-bottom: 12px;

    .quiz-position {
      .quiz-position-label {
        font-size: 14px;
        color: #808080;
        margin: 0 8px 0 0;
      }
    }

    .quiz-type {
      .quiz-type-label {
        font-size: 14px;
        font-weight: bold;
        color: #808080;
      }
    }
  }
</style>
